var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    { attrs: { id: "ranges-search-form" } },
    [
      _c(
        "b-col",
        { staticClass: "mt-3 mb-4 px-md-4", attrs: { md: "6" } },
        [
          _c("frame-style-slider", {
            attrs: { label: "Tradition vs Contemporary" },
            model: {
              value: _vm.selectedFilters.rating,
              callback: function ($$v) {
                _vm.$set(_vm.selectedFilters, "rating", $$v)
              },
              expression: "selectedFilters.rating",
            },
          }),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-3 px-4", attrs: { md: "6" } },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Budget:" } },
            [
              _c("b-form-radio-group", {
                staticClass: "w-100",
                attrs: { options: _vm.priceOptions, buttons: "" },
                model: {
                  value: _vm.selectedFilters.price,
                  callback: function ($$v) {
                    _vm.$set(_vm.selectedFilters, "price", $$v)
                  },
                  expression: "selectedFilters.price",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }